<template>
  <div
    class="w-full lg:sticky top-[100px] lg:max-w-[480px] shrink-0 bg-surface-grey-light rounded-md p-6 space-y-6"
    ref="ticketAreaRef"
  >
    <div class="space-y-1" v-if="event.parallel_external_ticketsale_primary_message || event.parallel_external_ticketsale_secondary_message">
      <div class="h3" v-if="event.parallel_external_ticketsale_primary_message">
        {{ event.parallel_external_ticketsale_primary_message }}
      </div>
      <div v-if="event.parallel_external_ticketsale_secondary_message">
        {{ event.parallel_external_ticketsale_secondary_message }}
      </div>
    </div>

    <BaseButton
      class="w-full relative group"
      color="primary"
      size="lg"
      :href="event.parallel_external_ticketsale_url"
      v-if="!event.parallel_external_ticketsale_eventpage_hide_find_tickets_button"
    >
      <span class="w-full flex items-center justify-between">
        <span class="text-wrap">{{ buttonText }}</span>
        <ArrowRightIcon class="w-4 h-4 ml-2 fill-current group-hover:animate-pulse-right" />
      </span>
    </BaseButton>

    <transition name="slidedown" mode="out-in" v-if="!event.parallel_external_ticketsale_eventpage_hide_find_tickets_button">
      <div
        v-if="isFixed"
        class="fixed mb-0 bottom-0 border-t border-surface-grey z-10 left-0 right-0 p-4 md:hidden bg-surface-light"
      >
        <BaseButton
          class="w-full"
          color="primary"
          size="lg"
          :href="event.parallel_external_ticketsale_url"
        >
          <span class="w-full flex items-center justify-between">
            <span class="text-wrap">{{ buttonText }}</span>
            <ArrowRightIcon class="w-4 h-4 ml-2 fill-current" />
          </span>
        </BaseButton>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import type { EventDetail } from '@/types';
import { getLocalizedEventValue } from '@/utils/eventItemUtil';

import ArrowRightIcon from '../icons/ArrowRightIcon.vue';
import BaseButton from '../ui/BaseButton.vue';

const props = defineProps<{
  event: EventDetail;
}>();

const { locale, t: $t } = useI18n();

const isFixed = ref(false);
const ticketAreaRef = ref<HTMLElement | null>(null);

const buttonText = computed(() =>
  getLocalizedEventValue(props.event, locale.value, 'button_text_buy_tickets') || $t('event.visit_external_shop')
);

function handleScroll() {
  if (ticketAreaRef.value) {
    const rect = ticketAreaRef.value.getBoundingClientRect();
    isFixed.value = rect.bottom <= 0;
  }
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>
